<template>
  <FormMultiSelect 
    :value="value"
    @input="$emit('input', $event)"
    :taggable="false"
    :options="dayOptions"
  />
</template>

<script>
export default {
  name: 'FormDaysWeek',
  props: {
    value: Array
  },
  data() {
    return {
      dayOptions: [
        { value: -1, name: 'Everyday' },
        { value: 0, name: 'Sunday' },
        { value: 1, name: 'Monday' },
        { value: 2, name: 'Tuesday' },
        { value: 3, name: 'Wednesday' },
        { value: 4, name: 'Thursday' },
        { value: 5, name: 'Friday' },
        { value: 6, name: 'Saturday' }
      ]
    }
  }
}
</script>